export default __webpack_public_path__ + "static/media/sfa-cross.70af9789.svg";